<template>
    <div class="block--small">
        <transition name="fade" mode="out-in">
            <div v-if="newPasswordSent">
                <h2>Nieuw wachtwoord verzonden</h2>
                <p>Als er een account bij ons bekend is is er een e-mail verstuurd naar <strong>{{email}}</strong> met een link om uw wachtwoord aan te passen.</p>
                <a href="/auth" class="button--cta" @click.prevent="changeAuthView('LoginForm')">Terug naar inlogscherm</a>
            </div>
            <form class="form" v-else>
                <h3>Wachtwoord vergeten?</h3>

                <p>Vul hieronder uw e-mailadres in en u ontvangt een e-mail met uw nieuwe wachtwoord.</p>
                <div class="form__group">
                    <input class="form__input--text" type="email" name="Email" placeholder="E-mailadres" v-model="email"/>
                </div>

                <div class="form__buttons">
                    <button type="submit" class="button--cta" @click.prevent="sendPasswordReset">Stuur nieuw wachtwoord</button>
                    <router-link :to="{ name: 'signin' }" class="button--link">Annuleren</router-link>
                </div>
            </form>
        </transition>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Component from 'vue-class-component';
    import firebase from 'firebase';
    import {scrollTo} from '@/utils';
    @Component
    export default class PasswordForm extends Vue {
        name = 'password-form';
        newPasswordSent = false;

        email = '';

        changeAuthView(value, event) {
            this.$emit('changeAuthComponent', value);
        }

        sendPasswordReset() {
            if (this.email !== undefined && this.email.length > 0) {
                firebase.auth().sendPasswordResetEmail(this.email).then(() => {
                    this.newPasswordSent = true;
                }).catch((error) => {
                    console.log('Reset', error.code, error.message);
                });
            }
        }
    }

    Vue.component(PasswordForm.name, PasswordForm);
</script>



// WEBPACK FOOTER //
// src/components/auth/forms/PasswordForm.vue